<template>
    <div class="wrapper" v-if="$store.getters['auth/user']">
        <audio id="audio_message" src="/sounds/message.mp3"></audio>
        <Sidebar />

        <div class="main" :class="{'margin-sidebar': !sidebar_toggled}">
            <Navbar />
            <main class="content">
                <child />
                <WebPhone v-if="$hasPermission('requests.call')" />
                <RequestDrawer />
                <BulkSMS />
                <ChangeStatus />
                <ChangeOperator />
                <NotSpam />
                <AgenciesManage/>
                <UserModal />
                <BlacklistedPhonesManage/>
                <BotsManage/>
<!--                <WebPhone2 />-->
            </main>
            <Footer />
        </div>
    </div>
<!--  <div class="main-layout">-->
<!--    <navbar />-->

<!--    <div class="container mt-4">-->
<!--      <child />-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import Navbar from '~/components/Navbar'
import feather from 'feather-icons';
import Sidebar from "../components/Sidebar";
import WebPhone from "../components/webphone/WebPhone";
import RequestDrawer from "../components/requests/RequestDrawer";
import BulkSMS from "../components/bulk_sms/BulkSMS";
import AgenciesManage from "../components/agencies/AgenciesManage";
import ChangeStatus from "../components/requests/bulk/ChangeStatus.vue";
import ChangeOperator from "../components/requests/bulk/ChangeOperator.vue";
import UserModal from "../components/users/UserModal.vue";
import NotSpam from "../components/requests/bulk/NotSpam.vue";
import BlacklistedPhonesManage from "../components/blacklisted-phones/BlacklistedPhonesManage.vue";
import BotsManage from "../components/telegram_bots/BotsManage.vue";
// import WebPhone2 from "../components/webphone/WebPhone2";

export default {
  name: 'MainLayout',

  components: {
      BotsManage,
      BlacklistedPhonesManage,
      NotSpam,
      UserModal,
    ChangeOperator,
    ChangeStatus,
      AgenciesManage,
      BulkSMS,
      RequestDrawer,
      WebPhone,
      // WebPhone2,
      Sidebar,
      Navbar
  },
    data: () => ({
        pong: [],
        now: null,
        history_online_status: [],
    }),
    computed: {
        online_status() {
            let trigger_seconds = 30;
            if (this.pong.length === 0) {
                return "offline";
            } else {
                if ((this.now - this.pong[0]) > trigger_seconds) {
                    return "offline";
                } else {
                    return "online";
                }
            }
        },
        sidebar_toggled: function () {
            return this.$store.getters['sidebar/toggle'];
        },
    },
    watch: {
      online_status(val, old) {
          if (val === 'offline' && this.history_online_status.length === 0) return;
          this.history_online_status.unshift(val);
          this.history_online_status = this.history_online_status.slice(0, 10);
          if (
              this.history_online_status.length > 2
              && this.history_online_status[0] === 'online'
              && this.history_online_status[1] === 'offline'
          ) {
              this.$bus.$emit('online_status:online_again');

          }
      }
    },
  mounted() {
      let self = this;
      feather.replace();
      setInterval(() => {
          this.now = moment().unix();
      }, 1000);
      let t = setInterval(() => {
          if (this.$store.getters['auth/user'] !== null) {
              clearInterval(t);
              Echo.join(`online`)
                  .here((users) => {
                      self.pushToPong(moment().unix())
                  })
                  .joining((user) => {
                      self.pushToPong(moment().unix())
                  })
                  .leaving((user) => {
                      self.pushToPong(moment().unix())
                  });
              Echo.private('online.pong')
                  .listen('.pong', (r) => {
                      self.pushToPong(moment().unix())
                  });
              Echo.private(`user.${this.$store.getters['auth/user'].id}`)
                  .listen('.user.logged', function (e) {
                      self.$store.dispatch('auth/fetchUser')
                          .then(() => {
                              let user = self.$store.getters['auth/user'];
                              let token = self.$store.getters['auth/token'];
                              if (user && user.token !== token) {
                                  self.$store.dispatch('auth/onLogout')
                                      .then(() => {
                                          self.$router.push({name: 'login'})
                                              .then(() => {
                                                  window.location.reload();
                                              });
                                      })
                              }
                          })
                  })
                  .listen('.user.logged_out', function (e) {
                      self.$store.dispatch('auth/onLogout')
                          .then(() => {
                              self.$router.push({name: 'login'})
                                  .then(() => {
                                      window.location.reload();
                                  });
                          })
                  })
                  .listen('.user.notice', function (e) {
                      let color = 'primary';
                      switch (e.type) {
                          case 'info': color = 'primary'; break;
                          case 'success': color = 'success'; break;
                          case 'danger': color = 'danger'; break;
                          case 'warning': color = 'warn'; break;
                      }

                      let duration = 'none';
                      if (e.duration) duration = e.duration * 1000;

                      let notification_params = {
                          color: color,
                          position: 'top-right',
                          title: e.title,
                          text: e.message,
                          buttonClose: false,
                          duration: duration,
                      };
                      if (duration !== 'none') notification_params.progress = 'auto';
                      self.$vs.notification(notification_params);

                      if (e.action && e.action === 'refresh' && e.duration) {
                          setTimeout(() => {
                              window.location.reload();
                          }, e.duration * 1000);
                      }

                      if (e.action && e.action === 'logout' && e.duration) {
                          setTimeout(() => {
                              self.$store.dispatch('auth/logout')
                                  .then(() => {
                                      self.$router.push({name: 'login'})
                                          .then(() => {
                                              window.location.reload();
                                          });
                                  })
                          }, e.duration * 1000);
                      }
                  })
                  .listen('.user.export_finished', function (e) {
                      self.$vs.notification({
                          color: 'success',
                          duration: 'none',
                          position: 'top-right',
                          title: 'Экспорт завершен, нажмите, чтобы скачать файл!',
                          text: '',
                          clickClose: true,
                          onClick: function () {
                              window.open(e.url, '_blank');
                          }
                      });
                  })
                  .listen('.chat.message.created', function (e) {
                      if (e.message.direction === 'IN') {
                          self.$vs.notification({
                              position: 'bottom-right',
                              duration: 3000,
                              title: 'Новое сообщение! Заявка №' + e.message.request_id,
                              text: e.message.text,
                              clickClose: true,
                              onClick: function () {
                                  self.toRequest(e.message.request_id);
                              }
                          });
                          try {
                              audio_message.play();
                          } catch (e) {

                          }
                      }
                  });
          }
      }, 500)
      this.$bus.$on('online_status:online_again',() => {
          console.log('ONLINE_AGAIN');
          // this.$message.info({
          //     message: 'Подключение восстановлено',
          //     duration: 3000,
          // });
      });
  },
    beforeDestroy() {
      if (this.$store.getters['auth/user']) {
          Echo.leave(`user.${this.$store.getters['auth/user'].id}`);
      }
      this.$bus.$off('online_status:online_again');
    },
    methods: {
        toRequest(id) {
            this.$router.push({
                name: 'request',
                params: {
                    id: id
                }
            });
        },
        pushToPong(t) {
            this.pong.unshift(t);
            this.pong = this.pong.slice(0, 2);
        }
    }
}
</script>

